// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-main {
  height: calc(100vh - 65px);
  overflow-y: scroll;
  padding-top: 20px;
  padding-bottom: 15px;
}
.employee-main .purpose .loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  z-index: 1;
}
.employee-main .bg-blue {
  background-color: #31d7e0 !important;
}
.employee-main .color-blue {
  color: #31d7e0 !important;
}
.employee-main .color-grey {
  color: #4e5857 !important;
}
.employee-main .color-blue {
  color: #41c8ff;
}
.employee-main .color-purple {
  color: #6d68aa;
}
.employee-main .agregar-foto {
  cursor: pointer;
  max-width: 100px;
  border-radius: 10px;
  margin: auto;
}
.employee-main .addEmployeeInfo-btn {
  background-color: white;
  border: 2px solid #6d68aa;
  color: #6d68aa;
}
.employee-main .img-employee {
  border: 1px solid rgba(78, 88, 87, 0.3882352941);
  border-radius: 10px;
}
.employee-main .agregar-foto img {
  border-radius: 10px 10px 0px 0px;
}
.employee-main .img-employee img {
  border-radius: 10px;
}
.employee-main .link-appearence {
  cursor: pointer;
  color: #1a0da8;
}
.employee-main .select-iformation {
  margin: 15px 0;
  padding: 0.375rem 1.25rem 0.375rem 0.75rem !important;
  height: 36px;
}
.employee-main .select-iformation:disabled {
  border: none;
  background-color: transparent !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none;
}
.employee-main .select-iformation::-ms-expand:disabled {
  display: none !important;
}
.employee-main .input-iformation:disabled {
  border: none;
  background-color: transparent !important;
}
.employee-main .title-icon {
  border-radius: 50%;
  background: #2cded3;
  width: 65px;
  height: 65px;
  position: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s;
}
.employee-main .title-icon svg {
  width: 45px;
  height: 45px;
  fill: rgb(255, 255, 255);
  stroke-width: 25px;
}
.employee-main .title-b2e {
  font-weight: 600;
  color: #3e3e3e !important;
}
.employee-main .title-b2e .card-header {
  color: #f4f4f4 !important;
  background-color: #6d68aa;
}
.employee-main .button-volver {
  font-size: 16px;
  font-weight: 500;
  border: 2px solid #6d68aa !important;
  color: #6d68aa !important;
  border-radius: 50rem;
  background: white !important;
  transition: all 0.4s ease-in-out;
  padding: 0.5rem 0.5rem;
  font-size: inherit;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 50px;
  width: 150px;
}
.employee-main .button-volver:hover {
  background-color: #efefef !important;
}
.employee-main .btn-moveStep {
  border: 2px solid #6d68aa !important;
  color: #6d68aa !important;
  border-radius: 50rem;
  background: white !important;
  transition: all 0.4s ease-in-out;
  padding: 0.5rem 0.5rem;
  font-size: inherit;
  margin-left: 10px;
  margin-right: 10px;
  width: 150px;
}
.employee-main .btn-save span {
  vertical-align: middle;
}
.employee-main .btn-salvar, .employee-main .btn-save {
  background-color: #45b9eb !important;
  color: white !important;
}
.employee-main .btn-salvar:hover, .employee-main .btn-save:hover {
  background: #5ac2ad !important;
  color: white;
}
.employee-main .btn-saveinfo {
  background: #BCE165;
  color: #fff;
}
.employee-main .btn-saveinfo:hover {
  background: #c8e77d;
  color: #444258;
}
.employee-main .btn-delinfo {
  background: #EC6376;
  color: white;
}
.employee-main .btn-delinfo:hover {
  background: #f47989;
  color: #444258;
}
.employee-main .hashtag-container {
  border: 1px solid #31d7e0;
  text-align: center;
  vertical-align: middle;
  padding: 0.5rem;
  width: 100%;
  cursor: pointer;
}
.employee-main .hashtag-container-active {
  background-color: #31d7e0;
  color: white;
  font-weight: bold;
}
.employee-main .card-title-bg-cyc {
  background-color: #45b9eb;
  color: white;
  margin-left: -1px;
  margin-top: -1px;
}
.employee-main .btn-acceder {
  border: 2px solid #2cded3 !important;
  color: #2cded3 !important;
}
.employee-main .btn-internal-vancancies {
  border: 2px solid #2cd8de;
  background-color: #2cded3;
  color: white;
  text-align: center;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: 20px;
  font-size: 18px;
  z-index: 9999;
}
.employee-main .btn-internal-vancancies:hover {
  border: 2px solid #2cded3 !important;
  background-color: white;
  color: #3e3e3e;
}
.employee-main .btn-img {
  opacity: 0.8;
  margin-top: -10px;
}
.employee-main .btn-img .animationEditText {
  transition: opacity 0.8s;
  opacity: 0;
}
.employee-main .btn-img:hover .animationEditText {
  opacity: 1;
}
.employee-main .btn-internal-comunication {
  border: 2px solid #7A6BE8;
  background-color: #7A6BE8;
  color: white;
  text-align: center;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: 20px;
  font-size: 18px;
}
.employee-main .btn-internal-comunication:hover {
  border: 2px solid #7A6BE8 !important;
  background-color: white;
  color: #3e3e3e;
}
.employee-main .btn-canal-denuncia {
  border: 2px solid #7A6BE8;
  color: #7A6BE8;
  text-align: center;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: 20px;
  font-size: 18px;
}
.employee-main .btn-canal-denuncia:hover {
  border: 2px solid #7A6BE8;
  background-color: #7A6BE8;
  color: white;
}
.employee-main .btn-acceder:hover {
  border: 2px solid #2cded3 !important;
  background-color: #2cded3;
  color: white !important;
}
.employee-main .competencia-main {
  margin-left: -30px;
}
.employee-main .competencia-main canvas {
  margin-left: -70px;
}
.employee-main .competencia-main .abilitiesChartHeight {
  height: 300px;
}
.employee-main .competencia-main .abilitiesAnswerPositive .progress-bar {
  background-color: #41C8FF;
  color: black;
}
.employee-main .competencia-main .abilitiesAnswerNegative .progress-bar {
  background-color: #9391a1;
}
.employee-main .competencia-main .competencia-btn {
  background-color: #7A6BE8;
  color: white;
  font-size: 1.25rem;
}
.employee-main .competencia-main .competencia-btn:hover {
  background-color: #5F52C4;
}
.employee-main .motivacion-main {
  margin-left: -30px;
}
.employee-main .motivacion-main .motivationsAnswerPositive .progress-bar {
  background-color: #41C8FF;
  color: black;
}
.employee-main .motivacion-main .motivationsAnswerNegative .progress-bar {
  background-color: #9391A1;
}
.employee-main .motivacion-main canvas {
  margin-left: -70px;
}
.employee-main .motivacion-main .motivationsChartHeight {
  height: 300px;
}
.employee-main .motivacion-main .motivacion-btn {
  background-color: #31d7e0;
  color: white;
  font-size: 1.25rem;
}
.employee-main .motivacion-main .motivacion-btn:hover {
  background-color: #5F52C4;
}
.employee-main .wheelEmployeePage-companyLogo {
  max-height: 100px;
}
.employee-main .wheelEmployeePage-wheel {
  margin-top: -75px;
}
.employee-main .wheelEmployeePage-last-row-adjust {
  margin-top: -150px;
}
.employee-main .wheelEmployeePage-list img {
  width: 20px;
}

@media screen and (max-width: 1300px) {
  .employee-main .wheelEmployeePage-last-row-adjust {
    margin-top: -240px;
  }
  .employee-main .wheelEmployeePage-companyLogo {
    max-height: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Views/Employee/Employee.sass"],"names":[],"mappings":"AAAA;EACC,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AACD;AAAC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AACF;AAAC;EACC,oCAAA;AAEF;AAAC;EACC,yBAAA;AAEF;AAAC;EACC,yBAAA;AAEF;AAAC;EACC,cAAA;AAEF;AAAC;EACC,cAAA;AAEF;AAAC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAEF;AAAC;EACC,uBAAA;EACA,yBAAA;EACA,cAAA;AAEF;AAAC;EACC,gDAAA;EACA,mBAAA;AAEF;AAAC;EACC,gCAAA;AAEF;AAAC;EACC,mBAAA;AAEF;AAAC;EACC,eAAA;EACA,cAAA;AAEF;AAAC;EACC,cAAA;EACA,qDAAA;EACA,YAAA;AAEF;AAAE;EACC,YAAA;EACA,wCAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;AAEH;AAAE;EACC,wBAAA;AAEH;AAAC;EACC,YAAA;EACA,wCAAA;AAEF;AAAC;EACC,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AAEF;AAAE;EACC,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;AAEH;AAAC;EACC,gBAAA;EACA,yBAAA;AAEF;AAAE;EACC,yBAAA;EACA,yBAAA;AAEH;AAAC;EACC,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAEF;AAAE;EACC,oCAAA;AAEH;AAAC;EACC,oCAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAEF;AAAC;EACC,sBAAA;AAEF;AAAC;EAEC,oCAAA;EACA,uBAAA;AACF;AACC;EAEC,8BAAA;EACA,YAAA;AAAF;AAEC;EACC,mBAAA;EACA,WAAA;AAAF;AACE;EACC,mBAAA;EACA,cAAA;AACH;AAAC;EACC,mBAAA;EACA,YAAA;AAEF;AADE;EACC,mBAAA;EACA,cAAA;AAGH;AADC;EACC,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAGF;AADE;EACC,yBAAA;EACA,YAAA;EACA,iBAAA;AAGH;AADC;EACC,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAGF;AADC;EACC,oCAAA;EACA,yBAAA;AAGF;AADC;EACC,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AAGF;AADE;EACC,oCAAA;EACA,uBAAA;EACA,cAAA;AAGH;AADC;EACC,YAAA;EACA,iBAAA;AAGF;AAFE;EACC,wBAAA;EACA,UAAA;AAIH;AAFG;EACC,UAAA;AAIJ;AAFC;EACC,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIF;AAFE;EACC,oCAAA;EACA,uBAAA;EACA,cAAA;AAIH;AAFC;EACC,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAIF;AAFE;EACC,yBAAA;EACA,yBAAA;EACA,YAAA;AAIH;AAFC;EACC,oCAAA;EACA,yBAAA;EACA,uBAAA;AAIF;AAFC;EACC,kBAAA;AAIF;AAHE;EACC,kBAAA;AAKH;AAJE;EACC,aAAA;AAMH;AAJG;EACC,yBAAA;EACA,YAAA;AAMJ;AAJG;EACC,yBAAA;AAMJ;AALE;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;AAOH;AANG;EACC,yBAAA;AAQJ;AANC;EACC,kBAAA;AAQF;AANG;EACC,yBAAA;EACA,YAAA;AAQJ;AANG;EACC,yBAAA;AAQJ;AAPE;EACC,kBAAA;AASH;AARE;EACC,aAAA;AAUH;AATE;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;AAWH;AAVG;EACC,yBAAA;AAYJ;AAVC;EACC,iBAAA;AAYF;AAVC;EACC,iBAAA;AAYF;AAVC;EACC,kBAAA;AAYF;AATE;EACC,WAAA;AAWH;;AATA;EAEE;IACC,kBAAA;EAWD;EATA;IACC,gBAAA;EAWD;AACF","sourcesContent":[".employee-main\r\n\theight: calc(100vh - 65px)\r\n\toverflow-y: scroll\r\n\tpadding-top: 20px\r\n\tpadding-bottom: 15px\r\n\t& .purpose .loading\r\n\t\tposition: absolute\r\n\t\ttop: 0\r\n\t\tleft: 0\r\n\r\n\t\twidth: 100%\r\n\t\theight: 100%\r\n\t\tbackground: rgba(255, 255, 255, 1)\r\n\t\tz-index: 1\r\n\t& .bg-blue\r\n\t\tbackground-color: #31d7e0 !important\r\n\r\n\t& .color-blue\r\n\t\tcolor: #31d7e0 !important\r\n\r\n\t& .color-grey\r\n\t\tcolor: #4e5857 !important\r\n\r\n\t& .color-blue\r\n\t\tcolor: #41c8ff\r\n\r\n\t& .color-purple\r\n\t\tcolor: #6d68aa\r\n\r\n\t& .agregar-foto\r\n\t\tcursor: pointer\r\n\t\tmax-width: 100px\r\n\t\tborder-radius: 10px\r\n\t\tmargin: auto\r\n\r\n\t& .addEmployeeInfo-btn\r\n\t\tbackground-color: white\r\n\t\tborder: 2px solid #6d68aa\r\n\t\tcolor: #6d68aa\r\n\r\n\t& .img-employee\r\n\t\tborder: 1px solid #4e585763\r\n\t\tborder-radius: 10px\r\n\r\n\t& .agregar-foto img\r\n\t\tborder-radius: 10px 10px 0px 0px\r\n\r\n\t& .img-employee img\r\n\t\tborder-radius: 10px\r\n\r\n\t& .link-appearence\r\n\t\tcursor: pointer\r\n\t\tcolor: #1a0da8\r\n\r\n\t& .select-iformation\r\n\t\tmargin: 15px 0\r\n\t\tpadding: 0.375rem 1.25rem 0.375rem 0.75rem !important\r\n\t\theight: 36px\r\n\r\n\t\t&:disabled\r\n\t\t\tborder: none\r\n\t\t\tbackground-color: transparent !important\r\n\t\t\t-webkit-appearance: none\r\n\t\t\t-moz-appearance: none\r\n\t\t\tbackground-image: none\r\n\r\n\t\t&::-ms-expand:disabled\r\n\t\t\tdisplay: none !important\r\n\r\n\t& .input-iformation:disabled\r\n\t\tborder: none\r\n\t\tbackground-color: transparent !important\r\n\r\n\t& .title-icon\r\n\t\tborder-radius: 50%\r\n\t\tbackground: #2cded3\r\n\t\twidth: 65px\r\n\t\theight: 65px\r\n\t\tposition: inline-block\r\n\t\tdisplay: flex\r\n\t\tjustify-content: center\r\n\t\talign-items: center\r\n\t\ttransition: transform 0.3s\r\n\r\n\t\t& svg\r\n\t\t\twidth: 45px\r\n\t\t\theight: 45px\r\n\t\t\tfill: rgb(255, 255, 255)\r\n\t\t\tstroke-width: 25px\r\n\r\n\t& .title-b2e\r\n\t\tfont-weight: 600\r\n\t\tcolor: #3e3e3e !important\r\n\r\n\t\t& .card-header\r\n\t\t\tcolor: #f4f4f4 !important\r\n\t\t\tbackground-color: #6d68aa\r\n\r\n\t& .button-volver\r\n\t\tfont-size: 16px\r\n\t\tfont-weight: 500\r\n\t\tborder: 2px solid #6d68aa !important\r\n\t\tcolor: #6d68aa !important\r\n\t\tborder-radius: 50rem\r\n\t\tbackground: white !important\r\n\t\ttransition: all 0.4s ease-in-out\r\n\t\tpadding: 0.5rem 0.5rem\r\n\t\tfont-size: inherit\r\n\t\tmargin-left: 10px\r\n\t\tmargin-right: 10px\r\n\t\tmargin-top: 50px\r\n\t\twidth: 150px\r\n\r\n\t\t&:hover\r\n\t\t\tbackground-color: #efefef !important\r\n\r\n\t& .btn-moveStep\r\n\t\tborder: 2px solid #6d68aa !important\r\n\t\tcolor: #6d68aa !important\r\n\t\tborder-radius: 50rem\r\n\t\tbackground: white !important\r\n\t\ttransition: all 0.4s ease-in-out\r\n\t\tpadding: 0.5rem 0.5rem\r\n\t\tfont-size: inherit\r\n\t\tmargin-left: 10px\r\n\t\tmargin-right: 10px\r\n\t\twidth: 150px\r\n\r\n\t& .btn-save span\r\n\t\tvertical-align: middle\r\n\r\n\t& .btn-salvar,\r\n\t& .btn-save\r\n\t\tbackground-color: #45b9eb !important\r\n\t\tcolor: white !important\r\n\r\n\t& .btn-salvar:hover,\r\n\t& .btn-save:hover\r\n\t\tbackground: #5ac2ad !important\r\n\t\tcolor: white\r\n\r\n\t& .btn-saveinfo\r\n\t\tbackground: #BCE165\r\n\t\tcolor: #fff\r\n\t\t&:hover\r\n\t\t\tbackground: #c8e77d\r\n\t\t\tcolor: #444258\r\n\t& .btn-delinfo\r\n\t\tbackground: #EC6376\r\n\t\tcolor: white\r\n\t\t&:hover\r\n\t\t\tbackground: #f47989\r\n\t\t\tcolor: #444258\r\n\r\n\t& .hashtag-container\r\n\t\tborder: 1px solid #31d7e0\r\n\t\ttext-align: center\r\n\t\tvertical-align: middle\r\n\t\tpadding: 0.5rem\r\n\t\twidth: 100%\r\n\t\tcursor: pointer\r\n\r\n\t\t&-active\r\n\t\t\tbackground-color: #31d7e0\r\n\t\t\tcolor: white\r\n\t\t\tfont-weight: bold\r\n\r\n\t& .card-title-bg-cyc\r\n\t\tbackground-color: #45b9eb\r\n\t\tcolor: white\r\n\t\tmargin-left: -1px\r\n\t\tmargin-top: -1px\r\n\r\n\t& .btn-acceder\r\n\t\tborder: 2px solid #2cded3 !important\r\n\t\tcolor: #2cded3 !important\r\n\r\n\t& .btn-internal-vancancies\r\n\t\tborder: 2px solid #2cd8de\r\n\t\tbackground-color: #2cded3\r\n\t\tcolor: white\r\n\t\ttext-align: center\r\n\t\tpadding-right: 30px\r\n\t\tpadding-left: 30px\r\n\t\tborder-radius: 20px\r\n\t\tfont-size: 18px\r\n\t\tz-index: 9999\r\n\r\n\t\t&:hover\r\n\t\t\tborder: 2px solid #2cded3 !important\r\n\t\t\tbackground-color: white\r\n\t\t\tcolor: #3e3e3e\r\n\r\n\t& .btn-img\r\n\t\topacity: .8\r\n\t\tmargin-top: -10px\r\n\t\t.animationEditText\r\n\t\t\ttransition: opacity .8s\r\n\t\t\topacity: 0\r\n\t\t&:hover\r\n\t\t\t.animationEditText\r\n\t\t\t\topacity: 1\r\n\r\n\t& .btn-internal-comunication\r\n\t\tborder: 2px solid #7A6BE8\r\n\t\tbackground-color: #7A6BE8\r\n\t\tcolor: white\r\n\t\ttext-align: center\r\n\t\tpadding-right: 30px\r\n\t\tpadding-left: 30px\r\n\t\tborder-radius: 20px\r\n\t\tfont-size: 18px\r\n\r\n\t\t&:hover\r\n\t\t\tborder: 2px solid #7A6BE8 !important\r\n\t\t\tbackground-color: white\r\n\t\t\tcolor: #3e3e3e\r\n\r\n\t& .btn-canal-denuncia\r\n\t\tborder: 2px solid #7A6BE8\r\n\t\tcolor: #7A6BE8\r\n\t\ttext-align: center\r\n\t\tpadding-right: 30px\r\n\t\tpadding-left: 30px\r\n\t\tborder-radius: 20px\r\n\t\tfont-size: 18px\r\n\r\n\t\t&:hover\r\n\t\t\tborder: 2px solid #7A6BE8\r\n\t\t\tbackground-color: #7A6BE8\r\n\t\t\tcolor: white\r\n\r\n\t& .btn-acceder:hover\r\n\t\tborder: 2px solid #2cded3 !important\r\n\t\tbackground-color: #2cded3\r\n\t\tcolor: white !important\r\n\r\n\t& .competencia-main\r\n\t\tmargin-left: -30px\r\n\t\tcanvas\r\n\t\t\tmargin-left: -70px\r\n\t\t.abilitiesChartHeight\r\n\t\t\theight: 300px\r\n\t\t.abilitiesAnswerPositive\r\n\t\t\t.progress-bar\r\n\t\t\t\tbackground-color: #41C8FF\r\n\t\t\t\tcolor: black\r\n\t\t.abilitiesAnswerNegative\r\n\t\t\t.progress-bar\r\n\t\t\t\tbackground-color: #9391a1\r\n\t\t& .competencia-btn\r\n\t\t\tbackground-color: #7A6BE8\r\n\t\t\tcolor: white\r\n\t\t\tfont-size: 1.25rem\r\n\t\t\t&:hover\r\n\t\t\t\tbackground-color: #5F52C4\r\n\r\n\t& .motivacion-main\r\n\t\tmargin-left: -30px\r\n\t\t.motivationsAnswerPositive\r\n\t\t\t.progress-bar\r\n\t\t\t\tbackground-color: #41C8FF\r\n\t\t\t\tcolor: black\r\n\t\t.motivationsAnswerNegative\r\n\t\t\t.progress-bar\r\n\t\t\t\tbackground-color: #9391A1\r\n\t\tcanvas\r\n\t\t\tmargin-left: -70px\r\n\t\t.motivationsChartHeight\r\n\t\t\theight: 300px\r\n\t\t& .motivacion-btn\r\n\t\t\tbackground-color: #31d7e0\r\n\t\t\tcolor: white\r\n\t\t\tfont-size: 1.25rem\r\n\t\t\t&:hover\r\n\t\t\t\tbackground-color: #5F52C4\r\n\r\n\t& .wheelEmployeePage-companyLogo\r\n\t\tmax-height: 100px\r\n\r\n\t& .wheelEmployeePage-wheel\r\n\t\tmargin-top: -75px\r\n\r\n\t& .wheelEmployeePage-last-row-adjust\r\n\t\tmargin-top: -150px\r\n\r\n\t& .wheelEmployeePage-list\r\n\t\t& img\r\n\t\t\twidth: 20px\r\n\r\n@media screen and ( max-width: 1300px )\r\n\t.employee-main\r\n\t\t& .wheelEmployeePage-last-row-adjust\r\n\t\t\tmargin-top: -240px\r\n\r\n\t\t& .wheelEmployeePage-companyLogo\r\n\t\t\tmax-height: 80px\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
